import { ReactNode } from 'react';
import './auth.scss';
import BeekinLogo from '../../assets/beekin-logo-w.png';
import { useSelector } from 'react-redux';
import { StoreState } from '../../types/state';
import { Redirect, useLocation } from 'react-router';
import { Message } from 'semantic-ui-react';

type AuthContainerProps = {
  children: ReactNode;
};
const AuthContainer = (props: AuthContainerProps) => {
  const { isAuthenticated, error } = useSelector((state: StoreState) => {
    const { isAuthenticated, error } = state.auth;
    return { isAuthenticated, error };
  });

  const { state }: { state: any } = useLocation();
  if (isAuthenticated) return <Redirect to={state?.from || '/'} />;

  return (
    <div className="auth-container">
      <div className="auth-content">
        <img className="beekin-logo" src={BeekinLogo} alt="beekin" />
        {error ? <Message negative>{error}</Message> : null}
        {props.children}
      </div>
      <footer></footer>
    </div>
  );
};

export default AuthContainer;
